export const NO_ACCOUNT_PROMISE = 'No account or sign-up required.'
export const LOCAL_PROCESSING_PROMISE = 'Processed locally on your device.'
export const NO_UPLOAD_PROMISE = 'Files are not uploaded to an application server.'
export const PERMANENT_FILE_PROMISE = 'Your files and sensitive inputs stay on your device.'
export const SENSITIVE_INPUT_PROMISE = 'Your sensitive tool inputs stay on your device.'
export const TOOL_DATA_PRIVACY_DETAIL = 'Tool inputs, settings, and outputs are processed locally and are not intentionally sent to an application server.'
export const PERMANENT_TRUST_TAGLINE = `${NO_ACCOUNT_PROMISE} ${PERMANENT_FILE_PROMISE}`
export const FOOTER_TRUST_PROMISE = 'Processed locally. No file uploads. No account required.'
export const TOOL_LOCAL_PROCESSING_PROMISE = 'Processed locally. Files stay on your device—not on an application server.'

export function toolTrustDetail(categoryName?: string) {
  if (categoryName === 'Calculators') return 'Calculations stay on your device.'
  if (categoryName === 'Text Tools') return 'Text is processed locally on your device.'
  if (categoryName === 'Developer Tools') return 'Sensitive developer inputs are processed locally on your device.'
  if (categoryName === 'Device Tools') return 'Device inputs and recordings are processed locally on your device.'
  if (categoryName === 'QR Tools') return 'QR inputs are processed locally on your device.'
  return TOOL_LOCAL_PROCESSING_PROMISE
}

export const CATEGORY_TRUST_COPY = {
  pdf: 'Work with PDFs locally without uploading documents to an application server. No account or sign-up required.',
  developer: 'Process sensitive text and developer inputs locally without sending them to an application server. No account required.',
  data: 'Selected files and pasted records stay on your device. No application-server upload or account required.',
  qr: 'Create or inspect QR content locally without an account. Decoded links open only when you choose.',
  text: 'Entered text stays on your device. No account or sign-up required.',
  calculators: 'Calculate instantly without creating an account. Entered values stay on your device.',
  device: 'No account required. Device access uses permission controls, and the tools do not upload recordings to an application server.',
  business: 'Create and download business documents locally with no account, sign-in, or cloud workspace.',
  media: 'Selected media and generated outputs stay on your device. No application-server upload or account required.',
} as const
